export const FETCH_STATIC_TEMPLATES = 'DEPARTMENT/FETCH_STATIC_TEMPLATES';
export const FETCH_STATIC_TEMPLATES_SUCCESS = 'DEPARTMENT/FETCH_STATIC_TEMPLATES_SUCCESS';
export const FETCH_STATIC_TEMPLATES_ERROR = 'DEPARTMENT/FETCH_STATIC_TEMPLATES_ERROR';
export const FETCH_APPAREL_ITEMS = 'DEPARTMENT/FETCH_APPAREL_ITEMS';
export const FETCH_APPAREL_ITEMS_SUCCESS = 'DEPARTMENT/FETCH_APPAREL_ITEMS_SUCCESS';
export const FETCH_APPAREL_ITEMS_ERROR = 'DEPARTMENT/FETCH_APPAREL_ITEMS_ERROR';
export const FETCH_PROMOTIONAL_ITEMS = 'DEPARTMENT/FETCH_PROMOTIONAL_ITEMS';
export const FETCH_PROMOTIONAL_ITEMS_SUCCESS = 'DEPARTMENT/FETCH_PROMOTIONAL_ITEMS_SUCCESS';
export const FETCH_PROMOTIONAL_ITEMS_ERROR = 'DEPARTMENT/FETCH_PROMOTIONAL_ITEMS_ERROR';
export const FETCH_DEPARTMENT = 'DEPARTMENT/FETCH_DEPARTMENT';
export const FETCH_DEPARTMENT_SUCCESS = 'DEPARTMENT/FETCH_DEPARTMENT_SUCCESS';
export const FETCH_DEPARTMENT_ERROR = 'DEPARTMENT/FETCH_DEPARTMENT_ERROR';
export const FETCH_BROCHURES = 'DEPARTMENT/FETCH_BROCHURES';
export const FETCH_BROCHURES_SUCCESS = 'DEPARTMENT/FETCH_BROCHURES_SUCCESS';
export const FETCH_BROCHURES_ERROR = 'DEPARTMENT/FETCH_BROCHURES_ERROR';
export const RESET_STATE = 'DEPARTMENT/RESET_STATE';